import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import PricingAdmin from '../components/rl/PricingAdmin';

function PricingAdminPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Pricing Admin
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Manage plans and promos. Protect this route by setting PRICING_ADMIN_TOKEN on the API server.
        </Typography>
      </Box>
      <PricingAdmin />
    </Container>
  );
}

export default PricingAdminPage;

